export const blog = [
    {
        title: "A Beginner's Guide to Artificial Intelligence.",
        date: "02 Jan 2023",
        comment: "05 Comment",
    },
    {
        title: "The Impact of AI on Everyday Life: What You Need.",
        date: "25 Feb 2023",
        comment: "07 Comment",
    },
    {
        title: "AI Revolutionizing Medicine and Patient Care.",
        date: "11 Mar 2023",
        comment: "21 Comment",
    },
    {
        title: "Ethical in AI: Navigating the Moral Landscape.",
        date: "28 Mar 2023",
        comment: "06 Comment",
    },
    {
        title: "AI and Business: How Companies Are Leveraging Artificial Intelligence.",
        date: "29 Apr 2023",
        comment: "11 Comment",
    },
]